// import {sha256} from "js-sha256";

export function setupBingPixel(event, name, data) {
  // ;(function(w, d) {
  //   if (!w.uetq) {
  //     w.uetq = w.uetq || []
  //
  //     const initUET = function() {
  //       const uetConfig = {
  //         ti: "343197917",
  //         enableAutoSpaTracking: true,
  //         // enableDebug: process.env.REACT_APP_DEBUG
  //       }
  //       uetConfig.q = w.uetq
  //       w.uetq = new window.UET(uetConfig)
  //
  //       if (w.uetq.addMsClkId && window.localStorage.getItem('msclkid'))
  //         w.uetq.addMsClkId(window.localStorage.getItem('msclkid'))
  //
  //       w.uetq.push("pageLoad")
  //     }
  //
  //     const script = d.createElement('script')
  //     script.async = true
  //     script.src = '//bat.bing.com/bat.js'
  //
  //     script.onload = script.onreadystatechange = function() {
  //       const readyState = this.readyState
  //       if (!readyState || readyState === "loaded" || readyState === "complete") {
  //         initUET()
  //         script.onload = script.onreadystatechange = null
  //       }
  //     }
  //
  //     const firstScript = d.getElementsByTagName('script')[0]
  //     firstScript.parentNode.insertBefore(script, firstScript)
  //   }
  // })(window, document)

  if (event) {
    // window.uet_report_conversion = function() {
      window.uetq = window.uetq || []
      window.uetq.push('event', name, {
        // click_id: window.localStorage.getItem('msclkid'),
        // transaction_id: sha256(`${name}_${window.session_uid}`),
        ...data
      })
    // }

    // window.uetq.push({
    //   ea: 'track',
    //   el: name,
    //   // ev: data?.revenue_value
    // })
  }
}